module.exports = __webpack_public_path__ + "static/img/esales-1.c2ef90d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zsy_esales/esales-1.png
// module id = 239
// module chunks = 6